import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { FavoritesProvider, CompareProvider } from "./context/FavoritesCompareContext";
import { I18nProvider } from "./context/I18nContext";
import { CurrencyProvider } from "./context/CurrencyContext";
import { ReferralProvider } from "./context/ReferralContext";
import { Toaster } from "./components/ui/sonner";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import WhatsAppButton from "./layout/WhatsAppButton";
import WhatsAppBottomBar from "./layout/WhatsAppBottomBar";
import MobileBottomNav from "./layout/MobileBottomNav";
import HomePage from "./pages/HomePage";
import ProductListPage from "./pages/ProductListPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import OrderTrackingPage from "./pages/OrderTrackingPage";
import { LoginPage, RegisterPage } from "./pages/AuthPages";
import { ForgotPasswordPage, ResetPasswordPage } from "./pages/ForgotPasswordPage";
import AuthCallback from "./pages/AuthCallback";
import AccountPage from "./pages/AccountPage";
import AdminPage from "./pages/AdminPage";
import InfoPage from "./pages/InfoPage";
import OfferPopup from "./components/OfferPopup";
import { FavoritesPage, ComparePage } from "./pages/FavoritesComparePages";
import WheelPage from "./pages/WheelPage";
import BecomeAmbassadorPage from "./pages/BecomeAmbassadorPage";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <I18nProvider>
        <CurrencyProvider>
        <ReferralProvider>
        <AuthProvider>
          <CartProvider>
            <FavoritesProvider>
              <CompareProvider>
              <ScrollToTop />
              <Header />
              <main className="flex-1">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/products" element={<ProductListPage />} />
                  <Route path="/products/:id" element={<ProductDetailPage />} />
                  <Route path="/cart" element={<CartPage />} />
                  <Route path="/checkout" element={<CheckoutPage />} />
                  <Route path="/track" element={<OrderTrackingPage />} />
                  <Route path="/track/:trackingNumber" element={<OrderTrackingPage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/register" element={<RegisterPage />} />
                  <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                  <Route path="/reset-password" element={<ResetPasswordPage />} />
                  <Route path="/auth/callback" element={<AuthCallback />} />
                  <Route path="/account" element={<AccountPage />} />
                  <Route path="/admin" element={<AdminPage />} />
                  <Route path="/favorites" element={<FavoritesPage />} />
                  <Route path="/compare" element={<ComparePage />} />
                  <Route path="/wheel" element={<WheelPage />} />
                  <Route path="/become-ambassador" element={<BecomeAmbassadorPage />} />
                  <Route path="/about" element={<InfoPage />} />
                  <Route path="/contact" element={<InfoPage />} />
                  <Route path="/help" element={<InfoPage />} />
                  <Route path="/security" element={<InfoPage />} />
                  <Route path="/partner" element={<InfoPage />} />
                  <Route path="/info/*" element={<InfoPage />} />
                </Routes>
              </main>
              <WhatsAppBottomBar />
              <Footer />
              <MobileBottomNav />
              <WhatsAppButton />
              <OfferPopup />
              <Toaster richColors position="top-center" />
              </CompareProvider>
            </FavoritesProvider>
          </CartProvider>
        </AuthProvider>
        </ReferralProvider>
        </CurrencyProvider>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
